/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React from "react";

import PropTypes from "prop-types";

import styled from "styled-components";

const propTypes = {
  alreadySelectedCity: PropTypes.string.isRequired,
  datalistRef: PropTypes.object.isRequired,
  filteredCities: PropTypes.array.isRequired,
  onCityChangeHandler: PropTypes.func.isRequired,
  onSearchCityClick: PropTypes.func.isRequired,
  searchedCity: PropTypes.string.isRequired,
  setShowDatalist: PropTypes.func.isRequired,
  showDatalist: PropTypes.bool.isRequired,
  isMeetingForm: PropTypes.bool
};

const SelectCity = ({
  onSearchCityClick,
  searchedCity,
  datalistRef,
  showDatalist,
  setShowDatalist,
  filteredCities,
  onCityChangeHandler,
  isMeetingForm = false
}) => {
  const content = (
    <>
      {
        filteredCities.length > 0 ? (
          filteredCities.map((city, i) => (
            <p
              className="each-city"
              data-value={city}
              key={i}
              onClick={(event) => onSearchCityClick(event.target.textContent)}
            >
              {city}
            </p>
          ))
        ) : (
          <p
            className="each-city"
            value={"Others"}
            onClick={(event) => onSearchCityClick(event.target.textContent)}
          >
            Others
          </p>
        )
      }
    </>
  );

  return (
    <Container ref={datalistRef} $isMeetingForm={isMeetingForm}>
      <Input
        autoComplete="off"
        className="input-city"
        name="city"
        placeholder="City"
        type="text"
        value={searchedCity}
        onChange={onCityChangeHandler}
        onFocus={() => setShowDatalist(true)}
      />
      {
        showDatalist && (
          <CityContainer className="cities-datalist" id="places">
            {content}
          </CityContainer>
        )
      }
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: ${(p) => (p.$isMeetingForm ? "100%" : "80%")};
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const CityContainer = styled.div`
    text-align: center;
    display: flex;
    margin-top: 2rem;
    flex-direction: column;
    border-radius: 1.2rem;
    max-height: 150px;
    width: 100%;
    background: #fff;
    overflow-y: scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;

    position: absolute;

    ::-webkit-scrollbar {
      display: none;
    }

    padding: 1rem 0;

  .each-city {
    font-size: 1.6rem;
    color: #6C6C6C;
    margin-bottom: 1rem;

    :hover {
      color: #6725f4;
      cursor: pointer;
    }
  }

  @media (max-width: 768px) {
    max-height: 150px;
    width: 100%;
  }
`;

const Input = styled.input`
  border-radius: 1.2rem;
  position: relative;
  padding: 0 2rem;
  width: 100%;
  font-size: 1.8rem;
  font-weight: 400;
  display: block;
  height: 5rem;
  line-height: 1;
  outline-width: 0px;
  border: none;
  border-left: 1px solid rgba(255,255,255, 0.3);;
  border-top: 1px solid rgba(255,255,255, 0.3);;
  backdrop-filter: blur(5px);
  box-shadow: 4px 4px 20px rgb(0 0 0 / 15%);
  color: #6C6C6C;
  transition: all 0.2s ease-in-out;
  -moz-appearance: textfield;


    &:hover {
      box-shadow: 4px 4px 20px rgb(0 0 0 / 25%);
    }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::placeholder {
    font-weight: 400;
    color: #6C6C6C;
  }

  @media (max-width: 768px) {
    height: 4.5rem;
    width: 100%;
  }

  @media (max-height: 660px) {
    height: 4.5rem;
  }

  @media (max-height: 600px) {
    height: 4.5rem;
  }
`;

SelectCity.propTypes = propTypes;

export default SelectCity;
